// Treasury wallets-directory module endpoint functions.
//
// Endpoints accept camelCase view-model inputs and return camelCase
// view-model outputs. Snake_case lives ONLY between the network and
// the parser.

import { adminApi } from '@core/api/httpClient'
import { WALLETS_DIRECTORY_ENDPOINT_PATHS } from './walletsDirectoryEndpointPaths'
import type { WalletsDirectoryListResponseDto } from './walletsDirectoryContracts'
import type {
  GetWalletsDirectoryParams,
  WalletsDirectoryListResponse,
} from '../types/walletsDirectoryTypes'
import { parseWalletsDirectoryListResponse } from './walletsDirectoryParser'

type WireListResponse = WalletsDirectoryListResponseDto | { data: WalletsDirectoryListResponseDto }

function unwrap<T>(payload: T | { data: T }): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return (payload as { data: T }).data
  }
  return payload as T
}

export async function getWalletsDirectory(
  params: GetWalletsDirectoryParams,
): Promise<WalletsDirectoryListResponse> {
  const queryParams: Record<string, string> = {}
  if (params.page) queryParams.page = String(params.page)
  if (params.limit) queryParams.limit = String(params.limit)
  if (params.investorId) queryParams.investorId = params.investorId
  if (params.investorName) queryParams.investorName = params.investorName
  if (params.investorEmail) queryParams.investorEmail = params.investorEmail
  if (params.kycStatus) queryParams.kycStatus = params.kycStatus
  if (params.minBalance) queryParams.minBalance = params.minBalance
  if (params.maxBalance) queryParams.maxBalance = params.maxBalance
  if (params.currencyCode) queryParams.currencyCode = params.currencyCode
  if (params.sortOrder) queryParams.sortOrder = params.sortOrder

  const { data } = await adminApi.get<WireListResponse>(WALLETS_DIRECTORY_ENDPOINT_PATHS.LIST, {
    params: queryParams,
  })
  return parseWalletsDirectoryListResponse(unwrap(data))
}
